import { Controller } from "@hotwired/stimulus";

// The appeal-submission accept/reject forms each POST their own hidden
// `resolution_note` field, but the free-text note input the moderator
// actually types into sits outside both forms (shared between them). This
// copies the note's current value into whichever form's hidden field is
// about to submit, so the note reaches the server instead of always
// submitting blank.
export default class extends Controller {
  static targets = ["note", "hidden"];

  copy() {
    const value = this.noteTarget.value;
    this.hiddenTargets.forEach((field) => {
      field.value = value;
    });
  }
}
